export const Link = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.49986 3.68239L7.14418 3.03806C8.7506 1.43165 11.3551 1.43165 12.9615 3.03806C14.5679 4.64448 14.5679 7.24899 12.9615 8.85541L12.3158 9.50116M3.68558 6.49667L3.03782 7.14443C1.4314 8.75084 1.4314 11.3554 3.03782 12.9618C4.64424 14.5682 7.24875 14.5682 8.85517 12.9618L9.49819 12.3187M6.33301 9.66659L9.66634 6.33325"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default Link
